import { ResponseModel } from "../models/ResponseModel";
import { AjaxService } from "../shared/services/AjaxService";

export type AdminStatType = "NewDevotees" | "AllDevotees";

export interface AdminStatusOverview {
  activeUsersCount?: number;
  deactivatedUsersCount?: number;
  activeRate?: number;
}

export interface AdminDevotee {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  mobileNumber?: string | null;
  email?: string | null;
  registrationDate?: string | null;
  approvedDate?: string | null;
  approvedDateTime?: string | null;
  status?: string | null;
  userType?: string | null;
  isActive: boolean;
  isEmailVerified: boolean;
  isMobileVerified: boolean;
}

export interface AdminStatData {
  registeredUserCount?: number;
  pendingApprovalCount?: number;
  allDevoteesCount?: number;
  userStatusOverview?: AdminStatusOverview;
  devotees?: AdminDevotee[];
}

export interface AdminUpdatePayload {
  userId: string;
  registrationStatus: string;
}

export interface DivineCareFilterDto {
  Name?: string | null;
  FromDate?: string | null;
  ToDate?: string | null;
  PageSize: number;
  Page: number;
}

export interface UserNotificationDto {
  DevoteeId: string
}

export interface NotifyAllDto {
  Filter: DivineCareFilterDto;
}

export const AdminService = {
  async getAdminStatData(type: string): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>(`/Admin/getAdminStatData?type=${type}`, null);
  },

  async getDivineCare(payload: DivineCareFilterDto): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>("/Admin/getDivineCare", payload);
  },

  async updateUser(payload: AdminUpdatePayload): Promise<ResponseModel> {
    return AjaxService.put<ResponseModel>("/Admin/update", payload);
  },

  async archiveDivineCare(payload: UserNotificationDto): Promise<ResponseModel> {
    return AjaxService.put("/Admin/archiveNotification", payload);
  },

  async notifyDivineCareUser(payload: UserNotificationDto): Promise<ResponseModel> {
    return AjaxService.post("/Admin/pushUserNotification", payload);
  },

  async notifyAllDivineCareUsers(payload: NotifyAllDto): Promise<ResponseModel> {
    return AjaxService.post("/Admin/pushAllUserNotification", payload);
  },

  async archiveAllDivineCare(payload: NotifyAllDto): Promise<ResponseModel> {
    return AjaxService.post("/Admin/archiveAllNotification", payload);
  }
};
